import React from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";

const ConfirmationModal = ({ 
  title = "Confirm Action", 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = "Confirm", 
  cancelText = "Cancel", 
  visible,
  isLoading 
}) => {
  return (
    <>
      {visible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", 
            zIndex: 1040, 
          }}
          onClick={onCancel} 
        ></div>
      )}

      <div
        className={`modal custom-modal fade ${visible ? "show" : ""}`}
        role="dialog"
        style={{ display: visible ? "block" : "none", zIndex: 1050 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>{title}</h3>
                <p>{message}</p>
              </div>
              <div className="modal-btn action-buttons">
                <div className="row">
                  <div className="col-6">
                    <Link
                      to="#"
                      className="btn btn-primary continue-btn"
                      onClick={onConfirm}
                    >
                      {isLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        confirmText
                      )}
                    </Link>
                  </div>
                  <div className="col-6">
                    <Link
                      to="#"
                      className="btn btn-primary cancel-btn"
                      onClick={onCancel}
                    >
                      {cancelText}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;
